import { CartesianChart, type CartesianChartProps } from './CartesianChart';

export type LineChartProps = Omit<CartesianChartProps, 'marks'>;

/** Monotone line chart with point dots and an enlarged active dot on hover. */
export const LineChart = (props: LineChartProps) => <CartesianChart {...props} marks='line' />;

LineChart.displayName = 'LineChart';
